import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "SIZELESS TWIN"
const scope = "デジタルツイン空間制作"
const str1 = "東京・馬喰町のギャラリー「PARCEL」と「まるかビルディング」の2会場で開催された、ファッション×NFTの展示「SIZELESS TWIN」のデジタルツイン会場の制作を行った。"
const str2 = "図面と写真からのフルスクラッチで、空間の質感まで忠実な再現を目指した。これにより、現地の同位置でスマートフォンから入場したときに、現実とバーチャルの境目を消すことができた。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.sizeless01.childImageSharp.original.src}
          pageimgw={data.sizeless01.childImageSharp.original.width}
          pageimgh={data.sizeless01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless05.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless06.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/sizeless07.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  sizeless01: file(relativePath: {eq: "sizeless01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
